import {Trans} from '@lingui/macro';
import React from 'react';

import {
  VirtualTableColumnCellsEnum,
  virtualTableRowCheckboxWrapperWidth,
} from '../../../components/common/table/helpers/tableHelpers';
import {AutolinkerModel} from '../../../models/api/autolinkerModel';
import {ResourceColumn, ResourceTableColumnTypesEnum} from '../commons/resourceTableTypes';

export enum AutolinkersTableColumnIdsEnum {
  REFERENCE_FORMAT = 'reference_format',
  DESCRIPTION = 'description',
  URL_BUILDER = 'url_builder',
  CREATED_DATE = 'created_date',
}

export const autolinkersTableColumns: ReadonlyArray<ResourceColumn<AutolinkerModel>> = [
  {
    id: AutolinkersTableColumnIdsEnum.REFERENCE_FORMAT,
    type: ResourceTableColumnTypesEnum.STRING_TEMPLATE,
    title: <Trans id="autolinkers-table-column-referenceformat">Reference format</Trans>,
    accessor: (autolinker) => autolinker.referenceFormat.pattern,
    expressionsAccessor: (autolinker) => autolinker.expressions,
    cellType: VirtualTableColumnCellsEnum.TEXT,
    settings: {
      sticky: {
        isSticky: true,
        stickyOffset: virtualTableRowCheckboxWrapperWidth,
      },
      cellWidth: {
        width: 200,
      },
    },
  },
  {
    id: AutolinkersTableColumnIdsEnum.DESCRIPTION,
    type: ResourceTableColumnTypesEnum.TEXT,
    title: <Trans id="autolinkers-table-column-description">Description</Trans>,
    accessor: (autolinker) => autolinker.description ?? '',
    cellType: VirtualTableColumnCellsEnum.TEXT,
    settings: {
      cellWidth: {
        width: 250,
      },
    },
  },
  {
    id: AutolinkersTableColumnIdsEnum.URL_BUILDER,
    type: ResourceTableColumnTypesEnum.STRING_TEMPLATE,
    title: <Trans id="autolinkers-table-column-urlbuilder">URL</Trans>,
    accessor: (autolinker) => autolinker.urlBuilder,
    expressionsAccessor: (autolinker) => autolinker.expressions,
    cellType: VirtualTableColumnCellsEnum.TEXT,
    settings: {
      cellWidth: {
        shouldFillRemainingWidth: true,
      },
    },
  },
  {
    id: AutolinkersTableColumnIdsEnum.CREATED_DATE,
    type: ResourceTableColumnTypesEnum.DATE,
    title: <Trans id="autolinkers-table-column-createddate">Date created</Trans>,
    accessor: (autolinker) => autolinker.createdAt,
    customFormat: {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
    },
    cellType: VirtualTableColumnCellsEnum.DATE,
    settings: {
      cellWidth: {
        width: 150,
      },
    },
  },
];
